// SubscriptionAlert.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import './SubscriptionAlert.css';

const SubscriptionAlert = ({ 
  visible = true, 
  onClose, 
  alertStyle = {}, 
  onActiveChange = () => {} // nuevo callback
}) => {
  const { currentUser } = useAuth();
  const [daysLeft, setDaysLeft] = useState(null);

  useEffect(() => {
    if (!currentUser) return;
    const userDocRef = doc(db, 'users', currentUser.uid);
    const unsubscribe = onSnapshot(userDocRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const userData = docSnapshot.data();
        if (userData.accessExpiresAt) {
          const expiresDate = userData.accessExpiresAt.toDate();
          const now = new Date();
          const diffMs = expiresDate - now;
          const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
          setDaysLeft(diffDays > 0 ? diffDays : 0);
        }
      }
    });
    return () => unsubscribe();
  }, [currentUser]);

  // Determinar si la alerta está "activa" en pantalla
  const isActive =
    visible &&
    daysLeft !== null &&
    daysLeft > 0 &&
    daysLeft <= 10;

  // Avisamos al padre si hay cambio:
  useEffect(() => {
    onActiveChange(isActive);
  }, [isActive, onActiveChange]);

  // Si no está activa, no renderizamos nada (return null)
  if (!isActive) {
    return null;
  }

  // Mensaje según días
  const mainMessage =
    daysLeft === 1
      ? '¡Cuidado! Te queda 1 día de suscripción...'
      : `¡Te quedan ${daysLeft} días de suscripción!`;

  return (
    <div className="subscription-alert active" style={alertStyle}>
      <span>
        {mainMessage}{" "}
        <span className="renewal-text">
          Para renovarla{" "}
          <a
            href="https://thethingapp.com/precios"
            target="_blank"
            rel="noopener noreferrer"
            className="renewal-link"
          >
            haz click aquí
          </a>
        </span>
      </span>
      <button className="close-alert" onClick={onClose}>
        x
      </button>
    </div>
  );
};

export default SubscriptionAlert;
